import React from 'react';
import './navbar.css';
import { Navbar, Nav, Form, Button} from 'react-bootstrap';

export default function (){
    return(
        <Navbar className="navbar" variant="dark">
            <Navbar.Brand href="#home">Delphi Knights</Navbar.Brand>
            <Nav className="mr-auto">
            <Nav.Link href="https://twitter.com/techie_knights">Leaderboards</Nav.Link>
            <Nav.Link href="https://twitter.com/techie_knights">Dev Blog</Nav.Link>
            <Nav.Link href="https://discord.gg/ZDEKXPw">Help</Nav.Link>
            </Nav>
            <Form inline>
            <Button variant="outline-info">Profile</Button>
            </Form>
        </Navbar>
    )
}
